

(function setupGeolocationPopup() {
  const metaobjectEntries = window?.Shopify?.CustomGeolocation?.metaobjectEntries || []
  if (!metaobjectEntries.length) {
    return
  }

  
  if (localStorage.getItem("prefers_current_locale") === "true") {
    return
  }
  
  let timezoneEntry
  const timezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
  for (const entry of metaobjectEntries) {
    if (entry.timezoneStr.trim().split(",").map(t => t.trim()).some(t => timezoneId.includes(t))) {
      timezoneEntry = entry
      break
    }
  }

  if (!timezoneEntry) {
    return
  }

  if (timezoneEntry.countryCode.toLowerCase() === window?.Shopify?.CustomGeolocation?.shopCountryCode?.toLowerCase()) {
    return
  }

  showPopup(timezoneEntry)
  
  async function showPopup(metaobjectEntry) {
    const res = await fetch("/?section_id=geolocation-popup")
    const text = await res.text()
    const div = document.createElement("div")
    div.innerHTML = text

    div.innerHTML = div.innerHTML
      .replace(/{country}/g, metaobjectEntry.country)
      .replace(/{url}/g, metaobjectEntry.url)
      .replace(/{flagUrl}/g, metaobjectEntry.flagUrl)
      .replace(/{countryCode}/g, metaobjectEntry.countryCode)
      .replace(/{currency}/g, metaobjectEntry.currency)

    document.body.appendChild(div)
    
    document.querySelector("#PopupModal-GeoPopup").show()

    document.querySelector("#GeoGoToOther").addEventListener("click", function() {
      window.location.href = metaobjectEntry.url
    })
    
    document.querySelector("#GeoStay").addEventListener("click", function() {
      document.querySelector('#PopupModal-GeoPopup').hide()
      localStorage.setItem("prefers_current_locale", "true")
    })

    document.querySelector("#ModalClose-GeoPopup").addEventListener("click", function() {
      localStorage.setItem("prefers_current_locale", "true")
    })
  }
  
})()